import styles from "./Profile.module.scss";
import { UserProfile } from "@clerk/clerk-react";
import clerkTheme from "../../../ui/ClerkTheme/ClerkTheme";
import Card from "../../../ui/Card/Card";
import urls from "../../../routes";
import Tabs from "../../../ui/Tabs/Tabs";
import { useNavigate, useParams } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  const { subTabValue } = useParams();

  return (
    <Card className={styles.card}>
      <Tabs
        classNames={{ list: styles.tabsList, content: styles.tabsContent }}
        value={subTabValue ?? "root"}
        onValueChange={(value) => {
          if (value === "root") {
            void navigate(urls.settings.profile.root);
          } else {
            void navigate(`${urls.settings.profile.root}/${value}`);
          }
        }}
        tabs={[
          {
            id: "root",
            label: "Details",
            content: (
              <UserProfile
                routing="path"
                path={urls.settings.profile.root}
                appearance={{
                  ...clerkTheme,
                  variables: {
                    fontSize: "14px",
                  },
                  elements: {
                    ...clerkTheme.elements,
                    header: {
                      display: "none",
                    },
                  },
                }}
              />
            ),
          },
          {
            id: "security",
            label: "Security",
            content: (
              <UserProfile
                routing="path"
                path={urls.settings.profile.root}
                appearance={{
                  ...clerkTheme,
                  variables: {
                    fontSize: "14px",
                  },
                  elements: {
                    ...clerkTheme.elements,
                    header: {
                      display: "none",
                    },
                  },
                }}
              />
            ),
          },
        ]}
      />
    </Card>
  );
}

export default Profile;
